export default __webpack_public_path__ + "static/media/elf-05.9b559220.jpg";